export enum LearningTrackStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export class LearningTrack implements ILearningTrack {

  constructor(
    public id: number, 
    public title: string,
    public synopsis: string,
    public tag: string, 
    public imageURL: string, 
    public steps: ILearningTrackStep[],
    public estimatedProgress: number) {
    this.id = id
    this.title = title
    this.tag = tag
    this.imageURL = imageURL
    this.steps = steps
    this.estimatedProgress = estimatedProgress
  }

  status(): LearningTrackStatus {
    if (this.steps === null) { 
      if (this.estimatedProgress === 100) {
        return LearningTrackStatus.COMPLETE
      } else if (this.estimatedProgress > 0) {
        return LearningTrackStatus.IN_PROGRESS
      }
    } else {
      let completeSteps = this.steps.filter(step => step.complete)
      if (completeSteps.length > 0) {
        return completeSteps.length === this.steps.length ? LearningTrackStatus.COMPLETE : LearningTrackStatus.IN_PROGRESS
      }
    }
    return LearningTrackStatus.NOT_STARTED
  }

  complete(): boolean {
    if (this.steps === null) { return this.estimatedProgress === 100 }
    return this.steps.filter(step => step.complete).length === this.steps.length && this.steps.length > 0
  }

  progress(): number {
    if (this.steps === null ) { return this.estimatedProgress / 100 }
    if (this.steps.length === 0) { return 0 } 
    return this.steps.filter(step => step.complete).length / this.steps.length
  }
}

export interface ILearningTrack {
  id: number
  title: string
  synopsis: string
  tag: string
  imageURL: string
  steps: ILearningTrackStep[]
  estimatedProgress: number
  status: () => LearningTrackStatus
  complete: () => boolean
  progress: () => number
}

export class LearningTrackStep implements ILearningTrackStep {

  //order: number
  previousStepOverview
  nextStepOverview

  constructor(
    public id: number, 
    public title: string,
    public synopsis: string,
    public image: string,
    public content: string, 
    public complete: boolean,
    public order:number,
  ) {
    this.id = id
    this.title = title
    this.synopsis = synopsis
    this.image=  image
    this.content = content 
    this.complete = complete
    this.order = order
  }

  overview(): ILearningTrackStepOverview {
    return {id: this.id, title: this.title}
  }
}

export interface ILearningTrackStep {
  id: number
  title: string
  synopsis: string
  image: string,
  content: string
  complete: boolean
  order?: number
  previousStepOverview?: ILearningTrackStepOverview
  nextStepOverview?: ILearningTrackStepOverview
  overview: () => ILearningTrackStepOverview
}

export interface ILearningTrackStepOverview {
  id: number
  title: string
}

export class LearningTrackTag implements ILearningTrackTag {

  constructor(
    public id: number, 
    public title: string,
    public icon: string,
    public colour: string
  ) {
    this.id = id
    this.title = title
    this.icon = icon
    this.colour = colour
  }
}

export interface ILearningTrackTag {
  id: number
  title: string
  icon: string
  colour: string
}

export class LatestTrackStep implements ILatestTrackStep {

  constructor(
    public trackTitle: string,
    public trackId: number,
    public step: LearningTrackStep
  ) {
    this.trackTitle = trackTitle
    this.trackId = trackId
    this.step = step
  }
}

export interface ILatestTrackStep {
  trackTitle: string
  trackId: number
  step: LearningTrackStep
}